export const colors = {
  brandPrimaryDefault: "#0070EB",
  brandPrimaryTint: "#C8E2FF",
  brandPrimaryShade: "#004EA3",
  contentBrandPrimary: "#0070EB",
  backgroundBrand: "#0070EB",
  borderBrand: "#0070EB",
};

export const text = {
  themeName: "Racing Dark",
};